import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function Content14({ data }) {
    const { content14ButtonLink, content14ButtonText, content14Text, content14Title, content14ButtonExternalLink } = data
    return (
        <div className='left-right-pattern-image-wrap light-green-bg-sec'>
            <div className='container sm-container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <h2 className='heading-level-1-i'>{content14Title && parser(content14Title)}</h2>
                        <p>{content14Text && parser(content14Text)}</p>
                        {content14ButtonExternalLink ? (
                            <a href={content14ButtonExternalLink} className="btn blue-btn">
                                {content14ButtonText}
                            </a>
                        ) : content14ButtonLink ? (
                            <a
                                className='btn blue-btn'
                                href={`mailto:${content14ButtonLink}`}
                            >
                                {content14ButtonText}
                            </a>
                        ) : null}
                    </div>
                </div>
            </div>

            <div className='g-btm-pattern-1'>
                <StaticImage
                    src='../../../images/btm-pattern-green-image.png'
                    alt='image'
                />
            </div>
        </div>
    )
}
